import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import { BRN_ALERT_DIALOG_DEFAULT_OPTIONS } from '@spartan-ng/brain/alert-dialog';
import { BrnDialogService } from '@spartan-ng/brain/dialog';
import type { AlertDialogOptions } from './alert-dialog.model';
import type { AlertDialogContext } from './alert-dialog-content.component';
import { AlertDialogContentComponent } from './alert-dialog-content.component';

@Injectable({
  providedIn: 'root',
})
export class AlertDialogService {
  private readonly _brnDialogService = inject(BrnDialogService);

  /**
   * Opens a global alert dialog and returns an Observable that emits `true` when
   * the user confirms (clicks the action button) or `false` when cancelled.
   */
  public open(options: AlertDialogOptions): Observable<boolean> {
    const context: AlertDialogContext = {
      title: options.title,
      description: options.description,
      cancelLabel: options.cancelLabel ?? 'Cancel',
      actionLabel: options.actionLabel ?? 'Continue',
      actionVariant: options.actionVariant ?? 'default',
    };

    const mergedOptions = {
      ...BRN_ALERT_DIALOG_DEFAULT_OPTIONS,
      role: 'alertdialog' as const,
      closeOnBackdropClick: false,
      closeOnOutsidePointerEvents: false,
    };

    const dialogRef = this._brnDialogService.open(
      AlertDialogContentComponent,
      undefined,
      context,
      mergedOptions
    );

    return dialogRef.closed$.pipe(
      map((result) => result === true)
    );
  }
}
